import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

const qs = (filters = {}) => {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

export const createExamPortal = async (data) => {
  const res = await axiosInstance.post("/exam-portal/create", data);
  return res.data;
};

export const getAllExamsPortal = async (filters = {}) => {
  const res = await axiosInstance.get(`/exam-portal/all${qs(filters)}`);
  return res.data;
};

export const getExamByIdPortal = async (id) => {
  const res = await axiosInstance.get(`/exam-portal/${id}`);
  return res.data;
};

export const updateExamPortal = async (id, data) => {
  const res = await axiosInstance.put(`/exam-portal/update/${id}`, data);
  return res.data;
};

export const updateExamStatusPortal = async (id, status) => {
  const res = await axiosInstance.put(`/exam-portal/status/${id}`, { status });
  return res.data;
};

export const deleteExamPortal = async (id) => {
  const res = await axiosInstance.delete(`/exam-portal/delete/${id}`);
  return res.data;
};

export const createExamSchedulePortal = async (data) => {
  const res = await axiosInstance.post("/exam-portal/schedule/create", data);
  return res.data;
};

export const getAllExamSchedulesPortal = async (filters = {}) => {
  const res = await axiosInstance.get(`/exam-portal/schedule/all${qs(filters)}`);
  return res.data;
};

export const updateExamSchedulePortal = async (id, data) => {
  const res = await axiosInstance.put(
    `/exam-portal/schedule/update/${id}`,
    data
  );
  return res.data;
};

/** Date changes MUST go through postpone — do not send examDate on update */
export const postponeExamSchedulePortal = async (id, data) => {
  const res = await axiosInstance.put(
    `/exam-portal/schedule/postpone/${id}`,
    data
  );
  return res.data;
};

export const updateExamScheduleStatusPortal = async (id, status) => {
  const res = await axiosInstance.put(`/exam-portal/schedule/status/${id}`, {
    status,
  });
  return res.data;
};

export const deleteExamSchedulePortal = async (id) => {
  const res = await axiosInstance.delete(`/exam-portal/schedule/delete/${id}`);
  return res.data;
};

export const getSyllabusTemplatesForSchedulePortal = async (filters = {}) => {
  const res = await axiosInstance.get(
    `/exam-portal/syllabus-templates${qs(filters)}`
  );
  return res.data;
};
